/* kc2-trailer.js: Trailer auf der Ankauf-Seite.
   Titelbild mit Knopf, Video laedt erst beim Klick (preload="none") und
   startet dann mit Ton. Mehrfach verwendbar ueber [data-kc2-trailer]. */
(function () {
  function init(box) {
    var video = box.querySelector('video');
    var btn = box.querySelector('[data-kc2-trailer-play]');
    if (!video || !btn) return;
    btn.addEventListener('click', function () {
      box.classList.add('is-playing');
      video.controls = true;
      video.muted = false;
      var p = video.play();
      if (p && p.catch) p.catch(function () { box.classList.remove('is-playing'); });
    });
    video.addEventListener('ended', function () {
      box.classList.remove('is-playing');
      video.controls = false;
      video.currentTime = 0;
    });
  }
  function run() { document.querySelectorAll('[data-kc2-trailer]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
